<template>
  <div class="featured-exams">
    <div class="featured-exams__container">
      <h4>Exames mais pesquisados</h4>
      <div
        v-if="loading"
        class="featured-exams__loading"
      >
        <spinner />
      </div>
      <div
        v-else
        class="featured-exams__list"
      >
        <div
          v-for="exam in featuredExams"
          :key="exam.id"
          class="featured-exams__item"
          @click="handleClick(exam)"
        >
          <div class="featured-exams__item-code">
            {{ exam.mnemonic }}
          </div>
          <span class="featured-exams__item-name">
            {{ exam.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import examGuideService from '@/api/examGuide'
import Spinner from '../../common/Spinner.vue'

export default {
  name: 'FeaturedExams',
  components: { Spinner },
  data: () => ({
    featuredExams: [],
    loading: false
  }),
  mounted () {
    this.loading = true
    examGuideService
      .mostSearched()
      .then((res) => {
        this.featuredExams = res.data
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
  methods: {
    handleClick (exam) {
      this.$router.push({
        path: '/exames/detalhes',
        query: { mnemonic: exam.mnemonic }
      })
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
.featured-exams {
  h4 {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: #7F1A54;
    margin-bottom: 24px;
  }
  &__loading {
    min-height: 330px;
    display: flex;
    justify-content: center;
    padding-top: 50px;
  }
  &__item-code {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #B0234B;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 12px;
    line-height: 12px;
    font-weight: bold;
  }
  &__container {
    max-width: 600px;
    margin: 0 auto;
    @media (max-width: 769px) {
      padding: 0 7%;
    }
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    width: calc(50% - 8px);
    background: #FFFFFF;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 8px;
    max-height: 64px;
    align-items: center;
    text-decoration: none !important;
    cursor: pointer;

    @media (max-width: 769px) {
      max-width: 400px;
      width: 100%;
      margin: 0 auto 8px;
    }
  }
  &__item-name {
    font-weight: 600;
    font-size: 16px;
    color: #7F1A54 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 210px;
    letter-spacing: 0;

    @media (max-width: 769px) {
      width: calc(100% - 72px);
      max-width: initial;
    }
  }
}
</style>
